module.exports = __webpack_public_path__ + "img/powered5.f3d92a1e.png";